// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6c8ed75e","453":"0d9c1124","732":"1144389c","977":"2a4be1da"}[chunkId] + ".chunk.js";
};